export default "__VITE_ASSET__bUq1MQ4d__"